<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="APP管理"
      class="app-edit"
      width="500px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="app"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="18">
          <el-form-item label="名称" prop="name">
            <el-input v-model="app.name" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="版本号" prop="version">
            <el-input v-model="app.version" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="程序文件" prop="filepath">
            <el-upload
                :action="action"
                :on-success="handleSuccessUpload"
                :on-error="handleErrorUpload"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-exceed="handleExceed"
                multiple
                :limit="1"
                :file-list="fileList">
              <el-button size="mini" type="primary">上传文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "AppEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        action: window.config.basicServerUrl + "files/upload/software",
        fileList: [],
        app: {
          pkid: 0,
          name: "",
          version: "",
          filepath: "",
        },
        ruleValidate: {
          name: {required: true, message: "不能为空",trigger: "blur"},
          version: {required: true, message: "不能为空",trigger: "blur"},
          filepath: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.app.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `appUpdates/${this.app.pkid}`)
          .then(resp => {
            this.app = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "appUpdates", this.app)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSuccessUpload(response) {
        this.app.filepath = response.fileUrl;
        this.$message.success("文件上传成功!");
      },
      handleErrorUpload() {
        this.$message.error("文件上传失败!");
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      handleRemove() {
        this.app.filepath = "";
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件， 共选择了 ${files.length + fileList.length} 个文件`);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
